<template>
  <div>
    <el-dialog
      v-if="isShow"
      title="Bulk Create Carrier Service Settings"
      :visible.sync="isShow"
      top="3vh"
      :fullscreen="isFullscreen"
      :close-on-click-modal="false"
    >
      <div v-if="step === -1">
        <div style="display: flex; justify-content: center;">
          <el-transfer
            id="bulk-create-transfer"
            v-model="transferredServiceIds"
            v-loading="isLoadingServices"
            :titles="['Services', 'Creating']"
            :data="modifiedServices"
            filterable
            filter-placeholder="Enter Service Name"
          />
        </div>
      </div>
      <div v-else>
        <CarrierServiceSettingEditForm
          ref="editForm"
          v-model="carrierServiceSettings[step]"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="isFullscreen = !isFullscreen">
          <FontAwesomeIcon
            v-if="isFullscreen"
            :icon="['fal', 'compress']"
          />
          <FontAwesomeIcon
            v-else
            :icon="['fal', 'expand']"
          />
        </el-button>
        <el-button @click.native="isShow = false">
          Cancel
        </el-button>
        <el-button
          :disabled="step === -1"
          @click.native="step -= 1"
        >
          Previous
        </el-button>
        <el-button
          type="primary"
          :loading="isSaving"
          :disabled="transferredServiceIds.length === 0"
          @click.native="step === -1 ? startEditServiceSettings() : nextStep()"
        >
          {{ showSteps }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CarrierServiceSettingEditForm from '@/components/Application/Manage/Account/CarrierServiceSettingEditForm'
export default {
  components: {
    CarrierServiceSettingEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    carrierId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      rawServices: [],
      modifiedServices: [],
      transferredServiceIds: [],
      serviceRateTypes: [],
      isShow: false,
      isSaving: false,
      isFullscreen: false,
      isLoadingServices: false,
      carrierServiceSettings: [],
      step: -1,
      totalSteps: 0
    }
  },
  computed: {
    showSteps () {
      if (this.step !== -1) { // If not first step
        if ((this.step + 1) === this.carrierServiceSettings.length) { // If is last step
          return `Create ${this.step + 1}/${this.totalSteps}`
        } else return `Next ${this.step + 1}/${this.totalSteps}` // If between first and last step
      } else return 'Next' // If first step
    }
  },
  created () {
    this.loadServices()
    this.loadServiceRateTypes() // For pre-select rate type when creating
  },
  methods: {
    loadServices () {
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.carrierId }
        builder.page = 1
        builder.limit = 500
        builder.order = 'name:asc'
      })
        .then(res => {
          this.rawServices = res
          this.formatServices()
        })
        .finally(() => {
          this.isLoadingServices = false
        })
    },
    formatServices () {
      this.rawServices.map(service => {
        this.modifiedServices.push({
          key: service.id,
          label: service.name
        })
      })
    },
    loadServiceRateTypes () {
      // Service Rate Types
      this.$sdk.dictionary_serviceratetype.list().then(res => {
        this.serviceRateTypes = res
      })
    },
    startEditServiceSettings () {
      // Added new carrierSetting to the carrierServiceSettings list
      this.transferredServiceIds.map(sID => {
        let service = this.rawServices.find(s => s.id === sID)
        if (this.carrierServiceSettings.findIndex(css => css.carrier_service.id === service.id) === -1) {
          let carrierServiceSetting = new this.$sdk.account_carrierservicesetting()
          carrierServiceSetting.carrier_service = service
          this.setDefaultProperties(carrierServiceSetting)
          this.carrierServiceSettings.push(carrierServiceSetting)
        }
      })
      // Remove the carrierSetting from carrierServiceSettings list where carrier already has been removed from the transfer
      this.carrierServiceSettings = this.carrierServiceSettings.filter(css => this.transferredServiceIds.findIndex(sID => sID === css.carrier_service.id) !== -1)

      this.step = 0
      this.totalSteps = this.carrierServiceSettings.length
    },
    nextStep () {
      this.$refs.editForm.$refs.carrierServiceSettingForm.validate((valid) => {
        if (valid) {
          if (this.step === (this.carrierServiceSettings.length - 1)) {
            this.createCarrierServiceSettings()
          } else this.step += 1
        }
      })
    },
    async createCarrierServiceSettings () {
      this.isSaving = true
      try {
        await Promise.all(this.carrierServiceSettings.map(async cs => {
          await this.$sdk.account_carrierservicesetting.create(cs, builder => {
            builder.context = { resource: 'account', id: this.accountId }
            builder.include = ['carrier_service', 'carrier_type', 'service_rate_type']
          })
        }))
      } catch (err) {
        this.$message({ message: `An error occurred while creating`, type: 'error' })
      }
      this.isSaving = false
      this.isShow = false
      this.$emit('created')
      this.$message({ message: 'Successfully created', type: 'success' })
      this.carrierServiceSettings = []
      this.transferredServiceIds = []
      this.step = -1
      this.totalSteps = 0
    },
    setDefaultProperties (carrierSetting) {
      carrierSetting.service_rate_type = this.serviceRateTypes.find(srt => srt.name === 'Displayed in All Areas')
      carrierSetting.cubic = 250
      carrierSetting.extra = 0.00
      carrierSetting.item_min = 0
      carrierSetting.item_max = 0
      carrierSetting.item_next_id = 0
      carrierSetting.service_labelqty = 1
      carrierSetting.autobook = true
      carrierSetting.crm_pickuptype = false
    }
  }
}
</script>

<style lang="scss">
  #bulk-create-transfer .el-transfer-panel {
    width: 280px;
  }
</style>
